import { TrashIcon } from '@/src/assets/icons'
import { useSessionStore } from '@/src/hooks/use_session_store'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseButton, type BaseButtonProps } from './BaseButton'

export interface DestructiveButtonProps extends Partial<BaseButtonProps> {
  /**
   * Set for actions that only discard local, unsaved state (e.g. "discard changes") instead of
   * mutating server data. Read-only users must still be able to trigger those, otherwise they get
   * stuck in the dialog with no way out.
   */
  ignoresReadonly?: boolean
}

export const DestructiveButton = forwardRef<HTMLButtonElement, DestructiveButtonProps>(({ ignoresReadonly, ...props }, ref) => {
  const { user } = useSessionStore()
  const { t } = useTranslation()
  const isBlockedByReadonly = !!user?.readonly && !ignoresReadonly

  return (
    <BaseButton
      colorScheme='red'
      variant='primary'
      iconLeft={<TrashIcon />}
      ref={ref}
      {...props}
      isDisabled={isBlockedByReadonly || props.isDisabled}
      tooltip={isBlockedByReadonly ? t('readonly_action_disabled') : props.tooltip}
    />
  )
})
